interface ToggleProps {
  checked: boolean;
  onChange: (v: boolean) => void;
  label: string;
  disabled?: boolean;
}

// iOS-style pill toggle (navy when on). A `role="switch"` button rather than a bare checkbox so
// it reads as the design's toggle and stays keyboard-operable.
export function Toggle({ checked, onChange, label, disabled }: ToggleProps) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={label}
      disabled={disabled}
      onClick={() => onChange(!checked)}
      className={
        'relative inline-flex h-5 w-9 shrink-0 items-center rounded-full transition-colors ' +
        'focus:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-1 ' +
        'disabled:cursor-not-allowed disabled:opacity-50 ' +
        (checked ? 'bg-accent' : 'bg-line-3')
      }
    >
      <span
        className={
          'inline-block h-4 w-4 transform rounded-full bg-white shadow-sm transition-transform ' +
          (checked ? 'translate-x-[18px]' : 'translate-x-0.5')
        }
      />
    </button>
  );
}
